import React from 'react';
import { Trans } from 'react-i18next';
import Tip from 'components/Common/Template/Tip';
import PopupAnniversary from './PopupAnniversary';

export const TabAnniversary = () => {
  return (
    <>
      <div className="content">
        <div className="tab img-area anniversary" />
        <div className="left-wrap">
          <div className="wrapper">
            <div className="large-title">
              <Trans i18nKey="BTY_W_T_ADD_ANNIVERSARY_T" />
            </div>
          </div>
          <div className="large-text">
            <Trans i18nKey="BTY_W_T_ADD_ANNIVER_LIMIT_3" />
          </div>
        </div>
      </div>
      <Tip subText={<Trans i18nKey="BTY_W_T_ADD_ANNIVER_GUIDE" />} />

      <PopupAnniversary />
    </>
  );
};

export default TabAnniversary;
